import type {
  AcademicRiskStudentRepository,
  ResponseAcademicRisk,
} from '@/domains/academicRisk';
import { academicRiskStudentApiService } from '../http/academicRiskStudent.api';

/**
 * Implementación del repositorio de estudiantes en riesgo académico usando API service
 * Actúa como intermediario entre el dominio y la capa HTTP para operaciones de consulta
 * de estudiantes con riesgos identificados, validando respuestas antes de devolverlas
 */
class AcademicRiskStudentApiRepository
  implements AcademicRiskStudentRepository
{
  /**
   * Obtiene todos los estudiantes con riesgos académicos identificados
   * Los datos se organizan por año y semestre académico
   * @throws Error si no se obtienen datos válidos del API
   */
  async getAcademicRiskStudent(): Promise<ResponseAcademicRisk> {
    const getResponse =
      await academicRiskStudentApiService.getAcademicRiskStudent();

    if (!getResponse)
      throw new Error('Error al obtener los riesgos academicos');

    return getResponse;
  }
}

export const academicRiskStudentApiRepository =
  new AcademicRiskStudentApiRepository();
